import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Route, Clock, MapPin, AlertTriangle } from "lucide-react";

const fmtDur = (s) => { const m = Math.round((s || 0) / 60); return m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}min` : `${m} min`; };
const fmtKm = (m) => `${((m || 0) / 1000).toFixed(1).replace(".", ",")} km`;

// Bloco 5 (Iter 99): resultado da otimização (OSRM) — sequência sugerida com ETA acumulado.
export function OtimizarDialog({ result, onClose }) {
  if (!result) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="otimizar-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Route className="w-5 h-5 text-orange-600" />Sequência otimizada</DialogTitle></DialogHeader>
        <div className="flex gap-3 text-sm">
          <span className="inline-flex items-center gap-1 rounded-full bg-orange-50 border border-orange-200 px-3 py-1" data-testid="otimizar-duracao"><Clock className="w-4 h-4 text-orange-600" />{fmtDur(result.duration_s)}</span>
          <span className="inline-flex items-center gap-1 rounded-full bg-slate-50 border px-3 py-1" data-testid="otimizar-distancia"><MapPin className="w-4 h-4 text-slate-600" />{fmtKm(result.distance_m)}</span>
          <span className="inline-flex items-center gap-1 rounded-full bg-slate-50 border px-3 py-1">{result.paradas} parada(s)</span>
        </div>
        <ol className="divide-y rounded-md border" data-testid="otimizar-lista">
          {result.sequencia.map((s) => (
            <li key={s.id} className="flex items-center gap-3 px-3 py-2 text-sm" data-testid={`otimizar-item-${s.id}`}>
              <span className="w-7 h-7 rounded-full bg-orange-600 text-white font-bold text-xs flex items-center justify-center shrink-0">{s.ordem}</span>
              <div className="flex-1 min-w-0">
                <div className="font-medium truncate">{s.bairro || "—"} <span className="text-muted-foreground">· #{s.numero_pedido || "s/n"}</span></div>
                <div className="text-xs text-muted-foreground truncate">{s.cliente_nome || ""}</div>
              </div>
              {s.sem_geo
                ? <span className="text-[10px] text-amber-700 inline-flex items-center gap-1" title="Bairro sem localização no mapa"><AlertTriangle className="w-3 h-3" />sem mapa</span>
                : <span className="text-xs font-semibold text-slate-700 whitespace-nowrap">~{s.eta_min} min</span>}
            </li>
          ))}
        </ol>
        {result.sem_geo?.length > 0 && (
          <p className="text-xs text-amber-700">{result.sem_geo.length} entrega(s) em bairros sem localização foram colocadas no fim. Localize os bairros em Rotas → Mapa.</p>
        )}
        <p className="text-xs text-muted-foreground">{result.persisted ? "A ordem foi salva e aparece no app do entregador." : "Simulação — a ordem não foi salva."}</p>
        <Button onClick={onClose} className="w-full bg-orange-600 hover:bg-orange-700" data-testid="otimizar-fechar">Fechar</Button>
      </DialogContent>
    </Dialog>
  );
}
